import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import {
  AvatarMedium,
  Footer,
  TabNav,
  LayoutSideNavigation,
  LayoutWrapperSideNav,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  NamedLink,
  ResponsiveImage,
  Page,
} from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { updateFavoriteProfiles, updateFavoriteListings } from '../../ducks/user.duck';
import config from '../../config';
import { createSlug } from '../../util/urlHelpers';

import facebookImage from '../../assets/freedomlySocialShare.png';
import twitterImage from '../../assets/freedomlySocialShare.png';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { IoPersonCircleOutline } from 'react-icons/io5';
import { PiArticle } from 'react-icons/pi';

import css from './FavoritesPage.css';

const siteTitle = config.siteTitle;

const FavoritesPageComponent = props => {
  const {
    favoriteListingsIds,
    favoriteProfilesIds,
    favoriteListings,
    favoriteProfiles,
    onUpdateFavoriteListings,
    onUpdateFavoriteProfiles,
    intl,
  } = props;

  const schemaTitle = intl.formatMessage({ id: 'FavoriteListingsPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'FavoriteListingsPage.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;

  const tabs = [
    {
      text: (
        <span className={css.tabText}>
          <FaRegHeart className={css.tabIcon} />
          <FormattedMessage id="FavoriteListingsPage.allTab" />
        </span>
      ),
      selected: window.location.href.includes('all'),
      linkProps: {
        name: 'FavoritesPage',
        params: { tab: 'all' },
      },
    },
    {
      text: (
        <span className={css.tabText}>
          <IoPersonCircleOutline className={css.tabIcon} />
          <FormattedMessage id="FavoriteListingsPage.freelancersTab" />
        </span>
      ),
      selected: window.location.href.includes('freelancers'),
      linkProps: {
        name: 'FavoritesPage',
        params: { tab: 'freelancers' },
      },
    },
    {
      text: (
        <span className={css.tabText}>
          <PiArticle className={css.tabIcon} />
          <FormattedMessage id="FavoriteListingsPage.listingsTab" />
        </span>
      ),
      selected: window.location.href.includes('listings'),
      linkProps: {
        name: 'FavoritesPage',
        params: { tab: 'listings' },
      },
    },
  ];

  const nav = <TabNav rootClassName={css.tabs} tabRootClassName={css.tab} tabs={tabs} />;

  const handleRemoveFavoriteProfile = id => {
    const newFavoriteProfilesIds = favoriteProfilesIds.filter(profileId => profileId !== id);
    onUpdateFavoriteProfiles(newFavoriteProfilesIds);
  };
  const handleRemoveFavoriteListing = id => {
    const listingUuids = favoriteListingsIds.map(id => id.uuid);
    const newFavoriteListingsIds = listingUuids.filter(listingId => listingId !== id);
    onUpdateFavoriteListings(newFavoriteListingsIds);
  };

  return (
    <Page
      contentType="website"
      title={schemaTitle}
      description={schemaDescription}
      facebookImages={[
        { url: `${config.canonicalRootURL}${facebookImage}`, width: 1200, height: 630 },
      ]}
      twitterImages={[
        { url: `${config.canonicalRootURL}${twitterImage}`, width: 600, height: 314 },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="FavoritesPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav className={css.navigation}>
          <div className={css.navcontainer}>
            <h1 className={css.title}>
              <FormattedMessage id="FavoriteListingsPage.title" />
            </h1>
            {nav}
          </div>
        </LayoutWrapperSideNav>
        <LayoutWrapperMain className={css.layoutWrapperMain}>
          <div className={css.listingsContainer}>
            {favoriteProfiles &&
              favoriteProfiles.length > 0 &&
              (window.location.href.includes('all') ||
                window.location.href.includes('freelancers')) && (
                <h2>
                  <FormattedMessage id="FavoriteListingsPage.favoriteFreelancersHeading" />
                </h2>
              )}
            {favoriteProfiles &&
              favoriteProfiles.length > 0 &&
              (window.location.href.includes('all') ||
                window.location.href.includes('freelancers')) && (
                <div className={css.listingCards}>
                  {favoriteProfiles.map(l => (
                    <NamedLink
                      className={css.interestListingsContainer}
                      key={l.id.uuid}
                      name="ProfilePage"
                      params={{ id: l.author.id.uuid }}
                    >
                      <div className={css.interestListingsContainerInfo}>
                        <AvatarMedium
                          className={css.favoriteAvatar}
                          user={l.author}
                          disableProfileLink
                        />
                        <div className={css.interestListingsInfo}>
                          <div className={css.interestListingsTitle}>
                            {l.author.attributes.profile.displayName}
                          </div>
                          <div className={css.interestListingsAuthor}>
                            {l.attributes.publicData.authorWhoAmI}
                          </div>
                        </div>
                      </div>
                      <FaHeart
                        className={css.favoriteIcon}
                        onClick={event => {
                          event.stopPropagation();
                          event.preventDefault();
                          handleRemoveFavoriteProfile(l.author.id.uuid);
                        }}
                      />
                    </NamedLink>
                  ))}
                </div>
              )}
            {favoriteListings &&
              favoriteListings.length > 0 &&
              (window.location.href.includes('all') ||
                window.location.href.includes('listings')) && (
                <h2>
                  <FormattedMessage id="FavoriteListingsPage.favoriteListingsHeading" />
                </h2>
              )}

            {favoriteListings &&
              favoriteListings.length > 0 &&
              (window.location.href.includes('all') ||
                window.location.href.includes('listings')) && (
                <div className={css.listingCards}>
                  {favoriteListings.map(l => (
                    <NamedLink
                      className={css.interestListingsContainer}
                      key={l.id.uuid}
                      name="ListingPage"
                      params={{ id: l.id.uuid, slug: createSlug(l.attributes.title) }}
                    >
                      <div className={css.interestListingsContainerInfo}>
                        <ResponsiveImage
                          rootClassName={css.rootForImage}
                          alt={l.attributes.title}
                          image={l.images[0]}
                          variants={['landscape-crop', 'landscape-crop2x']}
                        />
                        <div className={css.interestListingsInfo}>
                          <div className={css.interestListingsTitle}>{l.attributes.title}</div>
                          <div className={css.interestListingsAuthor}>
                            {l.author.attributes.profile.displayName}
                          </div>
                        </div>
                      </div>
                      <FaHeart
                        className={css.favoriteIcon}
                        onClick={event => {
                          event.stopPropagation();
                          event.preventDefault();
                          handleRemoveFavoriteListing(l.id.uuid);
                        }}
                      />
                    </NamedLink>
                  ))}
                </div>
              )}
            {(!favoriteProfiles || favoriteProfiles.length === 0) &&
              (!favoriteListings || favoriteListings.length === 0) && (
                <div className={css.emptyState}>
                  <p className={css.emptyStateText}>
                    <FormattedMessage
                      id="FavoriteListingsPage.noFavorites"
                      values={{
                        marketplaceLink: (
                          <NamedLink name="BrowseFreelancersPage" className={css.marketplaceLink}>
                            <FormattedMessage id="FavoriteListingsPage.marketplaceLinkText" />
                          </NamedLink>
                        ),
                      }}
                    />
                  </p>
                </div>
              )}
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const mapStateToProps = state => {
  const { favoriteListingsIds, favoriteProfilesIds, favoriteProfileListingsIds } = state.user;

  const listings = getListingsById(state, favoriteListingsIds);
  const profiles = getListingsById(state, favoriteProfileListingsIds);
  return {
    favoriteListingsIds,
    favoriteProfilesIds,
    favoriteListings: listings,
    favoriteProfiles: profiles,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateFavoriteProfiles: profileIds => dispatch(updateFavoriteProfiles(profileIds)),
  onUpdateFavoriteListings: listingIds => dispatch(updateFavoriteListings(listingIds)),
});

const FavoritesPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(FavoritesPageComponent);

FavoritesPage.loadData = {};

export default FavoritesPage;
